// extracted by mini-css-extract-plugin
module.exports = {"statVideoTitle":"Stats_statVideoTitle__3gvBR","statsColumn":"Stats_statsColumn__YoBmx"};